//procoldash@gmail.com
//procol2020


import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './Components/Header'
import logo from './logoprocol.png';
import Inversion from './Components/Inversion/Inversion';
import Tabla from './Components/Inversion/Tabla';
import Sectores from './Components/Inversion/Sectores';
import PIB from './Components/FMI/PIB'
import TablaFMI from './Components/FMI/TablaFMI';
import Exportaciones from './Components/Exportaciones/Exportaciones';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Cadenas from './Components/Exportaciones/Cadenas';
import Balanza from './Components/Exportaciones/Balanza';
import Titles from './Components/Titles';
import Poblacion from './Components/Poblacion/Poblacion';
import Clasemedia from './Components/Poblacion/Clasemedia';
import Pobreza from './Components/Poblacion/Pobreza';
import Turismo from './Components/Turismo/Turismo';
import Legal from './Components/Legal/Legal';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ZF from './Components/Legal/ZF';
import DGT from './Components/Turismo/DGT';
import LastDate from './Components/LastDate';
import LineaPobreza from './Components/Poblacion/LineaPobreza';



const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '25px',
    flexGrow: 1,
    width: '90%',
    margin: 'auto',
    paddingBottom: '25px',
    display: 'grid',
    alignSelf: 'center',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  date: {
    paddingTop: '25px',
    flexGrow: 1,
    width: '90%',
    margin: 'auto',
    display: 'grid',
  }
}));




function getWindowDimensions() {



  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}


function isPhone(window) {
  if (window.width > 1024) {
    return false
  } else {
    return true
  }
}

function App() {
  const classes = useStyles();

  //Get if is mobile or desktop
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [phone, setPhone] = useState(isPhone(windowDimensions))

  //PDF stuffs
  const ref = React.createRef();

  useEffect(() => {

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
      setPhone(isPhone(windowDimensions))
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [windowDimensions, phone]);



  return (

    <div className="App">

      <div className='container' ref={ref}>
        <Header phone={phone} logo={logo}></Header>

        <div className={classes.date}>
          <Grid container spacing={3} alignItems="center" direction="row"
            justify={phone ? 'center' : 'flex-start'}>
            <LastDate />
          </Grid>
        </div>


        <div className={classes.root}>
          <Grid container spacing={3} alignItems="center" direction="row"
            justify="center">
            <Grid item xs={12} sm={12} lg={8}>
              <PIB phone={phone}></PIB>
            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <TablaFMI></TablaFMI>
            </Grid>
          </Grid>

        </div>



        {/*INVERSION*/}
        <Titles
          title={'CIFRAS DE IED EN COLOMBIA'}
          subtitle={'Fuente: Balanza de Pagos – Banco de la República'} />


        <div className={classes.root}>
          <Grid container spacing={3} alignItems="center" direction="row"
            justify="center">
            <Grid item xs={12} sm={12} lg={6}>
              <Inversion phone={phone}></Inversion>
            </Grid>


            <Grid item xs={12} sm={12} lg={6}>
              <Sectores phone={phone}></Sectores>
            </Grid>

            <Grid item xs={12} sm={12} lg={8}>
              <Tabla phone={phone}></Tabla>
            </Grid>
          </Grid>
        </div>


        {/*Exportaciones */}


        <Titles
          title={'BALANZA COMERCIAL'}
          subtitle={'Fuente: DANE-DIAN '} />

        <div className={classes.root}>
          <Grid container spacing={3} alignItems="center" direction="row"
            justify="center">
            <Grid item xs={12} sm={12} lg={4}>
              <Exportaciones phone={phone}></Exportaciones>
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Balanza phone={phone}></Balanza>
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <Cadenas phone={phone}></Cadenas>
            </Grid>


          </Grid>

        </div>
        {/*Turismo */}
        <div className="turirmo">
          <Titles
            title={'TURISMO'}
            subtitle={'Fuente: Migración Colombia, Banco de la República.'} />
          <div className={classes.root}>
            <Grid container spacing={3} alignItems="center" direction="row" justify="center">
              <Grid item sm={6} xs={12}>
                <DGT />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Turismo />
              </Grid>

            </Grid>
          </div>




        </div>

        <div className="pob">
          <Titles
            title={'POBLACIÓN'}
            subtitle={'Fuente: DANE'} />
          <div className={classes.root}>
            <Paper className={classes.paper}>

              <Poblacion />
              <Clasemedia />
              <Pobreza />
              <LineaPobreza />
            </Paper>
          </div>




        </div>


        <div classname='legal'>
          {/*Zonas Francas */}
          <Titles title={'ZONAS FRANCAS'}
            subtitle={'Fuente : Gerencia de Servicios Legales'} ></Titles>
          <ZF />

          <Titles
            title={'ACUERDOS'}
            subtitle={'Colombia tiene acceso a más de 60 países con más de 1.500 millones de consumidores a través de su red de acuerdos.'}
            subtitle2={'Fuente : Gerencia de Servicios Legales'} />

          <Legal />
        </div>
      </div>






    </div>
  );
}

export default App;
